import { isValidAsZipcode } from '@/twapp/misc/validation';
import * as yup from 'yup';

yup.setLocale({
    mixed: {
        required: ({label}) => `'${label} saknas`,
    },
    string: {
        max: ({label, max}) => `'${label}' får vara max ${max} tecken`,
    },
    number: {
        min: ({label, min}) => `'${label}' måste vara minst ${min}`,
    },
});

yup.addMethod(yup.string, 'tromanZipcode', function tromanZipcode() {
  return this.test({
    name: 'tromanZipcode',
    message: ({label}: yup.MessageParams) => `'${label}' är inte ett giltigt postnummer`,
    test: (value: string|undefined) => !value || isValidAsZipcode(value),
  });
});

yup.addMethod(yup.string, 'tromanEmail', function tromanEmail() {
  return this.test({
    name: 'tromanEmail',
    message: ({label}: yup.MessageParams) => `'${label}' är inte en giltig e-postadress`,
    test: (value: string|undefined) => !value || /^[^\r\n@]+@[^\r\n@]+$/.test(value),
  });
});